import * as S from "./style";
import { useAuth } from "context/AuthContext";
import { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router";
//Components
import ActionButtonLoad from "../../components/Button/ActionButtonLoad";
import CancelButton from "../../components/Button/CancelButton";
import Forms from "../../components/Modals/Order/Create/CreateOrder";
import TitleOrder from "../../components/Title/TitleOrder";
import CreatePayment from "../../components/Modals/Payment/Create";
//hooks
import useLoading from "../../hooks/useLoading";
import { useMultipleModal } from "../../hooks/useMultipleModal";
//Interface
import { IFrame } from "Interfaces/IFrame";
import { InputsSale } from "../../Interfaces/IOrder";

export default function NewOrder() {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<InputsSale>();

  const UserAuthenticated = useAuth();
  const {
    isLoading: isLoadingCadastro,
    startLoading: startCadastro,
    stopLoading: stopCadastro,
  } = useLoading();

  const navigate = useNavigate();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const [idCustom, setIdCustom] = useState<number | null>(null);
  const [payload, setPayload] = useState<any>(null);
  const [nameCustomer, setNameCustomer] = useState("");
  const [selectedProducts, setSelectedProducts] = useState<IFrame[]>([]);
  const [totalOrder, setTotalOrder] = useState<number | 0>(0);

  // Estado para armazenar os dados recebidos do componente filho
  const [titleData, setTitleData] = useState({
    user_id: null,
    user_name: null,
    date_sale: '',
  });

  //Cadastrar
  // ... previous code remains the same
  const onSubmit: SubmitHandler<InputsSale> = async (data) => {
    startCadastro();
    try {
      const items = selectedProducts.map((product) => {
        // Criar o objeto base do item
        let item: {
          type: string;
          id: number;
          quantity: number;
          user_id: number;
          promotions?: {
            promotion_id: number | null;
            paymentable_type: string | null;
            paymentable_id: number | null;
          }[];
        } = {
          type: product.type,
          id: product.id,
          quantity: product.amount || 1,
          user_id: product.user_id,
        };

        // Adicionar promotions apenas se pelo menos um dos campos não for nulo/undefined
        if (product.promotion_id !== undefined && product.promotion_id !== null &&
          product.paymentable_type !== undefined && product.paymentable_type !== null &&
          product.paymentable_id !== undefined && product.paymentable_id !== null) {
          item.promotions = [{
            promotion_id: product.promotion_id,
            paymentable_type: product.paymentable_type,
            paymentable_id: product.paymentable_id,
          }];
        }

        return item;
      });

      const payload = {
        user_id: titleData.user_id || Number(UserAuthenticated.user?.id),
        customer_id: idCustom || null, // Utiliza o ID do cliente
        items: items, // Array de IDs dos produtos
        number_ata: data.number_ata,
        date_sale: titleData.date_sale || new Date().toISOString().split('T')[0],
      };

      setPayload(payload);
      toggleModalVisibility("payment");
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro.");
    } finally {
      stopCadastro();
    }
  };

  // Função para receber os dados do componente filho
  const handleTitleDataChange = (data: any) => {
    setTitleData(data);
  };

  return (
    <S.Container>
      <TitleOrder onDataChange={handleTitleDataChange} />

      <S.ContentOrder>
        <Forms
          totalOrderTable={setTotalOrder}
          setSelectedTable={setSelectedProducts}
          setSelectedCustomer={setIdCustom}
          setNameCustomer={setNameCustomer}
          errors={errors}
          register={register}
        />
      </S.ContentOrder>

      <S.Footer>
        <S.ContentButton>
          <CancelButton name="Cancelar" onClick={() => navigate("/venda")} />
          <ActionButtonLoad
            name="Ir para pagamentos"
            status={isLoadingCadastro}
            onClick={handleSubmit(onSubmit)}
          />
        </S.ContentButton>
      </S.Footer>

      <CreatePayment
        dataRequest={payload}
        isOpen={isOpenModal("payment")}
        setModalClose={() => toggleModalVisibility("payment")}
        subtotal={totalOrder}
      />
    </S.Container>
  );
}
